export default "__VITE_ASSET__DzHdOgrc__"